import React, { useRef, useEffect } from "react";
import "./home_siete.css";
import Elipse from "../../../assets/imgs/home_siete/Ellipse.png";
import Line from "../../../assets/imgs/home_siete/Line.png";
import Dot from "../../../assets/imgs/home_siete/Dot.png";
import Comenta from "../../comentario/comenta/Comenta";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const Home_siete = () => {
  const [t, i18n] = useTranslation("home");
  const [popup, setPopup] = useState(false);

  const isMobile = useRef(false);
  const [sectionCss, setSectionCss] = useState({});

  useEffect(() => {
    const width = window?.innerWidth;
    if (width <= 820) {
      isMobile.current = true;
    } else {
      isMobile.current = false;
    }
  }, []);

  useEffect(() => {
    if (!isMobile.current) return;
    console.log("👽 Cambio popup ", popup);
    if (popup) {
      setSectionCss({
        height: "550px",
      });
    } else {
      setSectionCss({});
    }
  }, [popup]);

  return (
    <div className="home_siete" style={sectionCss}>
      <div className="escuchar_ideas">
        <div dangerouslySetInnerHTML={{ __html: t("leaders.quote") }}></div>
        {/* <p>
            <span className="parrafo1">El mundo requiere de <span className="lideres">líderes</span> <br/> </span> 
            <span className="parrafo2">comprometidos con el cambio de <br/> </span>
            <span className="parrafo3">mentalidad. <span className="ideas">¡Quiero escuchar tus ideas!</span> </span>
          </p> */}
      </div>
      <div className="line_div">
        <img className="line" src={Line} />
      </div>
      <div className="elipse_div">
        <img className="H7_elipse" src={Elipse} />
      </div>
      <div className="dot_div">
        <img className="H7_dot" src={Dot} id="H7_dot-animated" />
      </div>
      <div className="escribeme_div">
        <div
          className="escribeme"
          onClick={(e) => {
            e.preventDefault();
            setPopup(true);
          }}
        >
          {t("leaders.write-me")}
        </div>
        {popup && (
          <div className="index">
            <Comenta popup={popup} setPopup={setPopup} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Home_siete;
